
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { TypeAttendance, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class TypeAttendanceEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    typeAttendance: TypeAttendance;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getTypeAttendance()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getTypeAttendance(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.typeAttendance = data;
                this.onDataChanged.next(this.typeAttendance);
                resolve(this.typeAttendance);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('typeAttendance/' + this.routeParams.id).subscribe((res: TypeAttendance ) => {
                    this.typeAttendance = res;
                    this.onDataChanged.next(this.typeAttendance);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(typeAttendance): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('typeAttendance/', typeAttendance).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(typeAttendance): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('typeAttendance/', typeAttendance).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(typeAttendance): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('typeAttendance/' + typeAttendance.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): TypeAttendance {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
